





































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ColloquiInfo } from "../../_models/colloquiInfo";
import * as user from "../../_store/user.module"
import { bus } from "../../main"

@Component
export default class DetailsQuestionarioColloquio extends Vue {
  @Prop() info!: any; //ho due tipi di info: 1) azienda,incompleta perche' le info dell'azienda sono nello storage 2)tutor istituto, complete

  private idColloquio: number;
  private denominazione: string;
  private sede: string;
  private telefono: string;
  private emailAzienda: string;
  private nomeSelezionatore: string;
  private cognomeSelezionatore: string;
  private posizioneRichiesta: string;
  private valutazione: string;
  private note: string;

  private nomeAllievo: string;
  private cognomeAllievo: string;
  private classeAllievo: string;
  private luogoNascita: string;
  private dataNascita: string;
  private comuneAllievo: string;
  private indirizzoAllievo: string;
  private capAllievo: string;
  private provinciaAllievo: string;

  constructor() {
    super();
    this.idColloquio = this.info.idColloquio;
    this.denominazione = this.info.denominazione;
    this.sede = this.info.sede;
    this.telefono = this.info.telefono;
    this.emailAzienda = this.info.emailAzienda;
    this.nomeSelezionatore = this.info.nomeSelezionatore;
    this.cognomeSelezionatore = this.info.cognomeSelezionatore;
    this.posizioneRichiesta = this.info.posizioneRichiesta;
    this.valutazione = this.info.valutazione;
    this.note = this.info.note;

    this.nomeAllievo = this.info.nomeUtente;
    this.cognomeAllievo = this.info.cognomeUtente;
    this.classeAllievo = this.info.classe;
    this.luogoNascita = this.info.luogoNascita;
    this.dataNascita = this.info.dataNascita;
    this.comuneAllievo = this.info.comuneUtente;
    this.indirizzoAllievo = this.info.indirizzoUtente;
    this.capAllievo = this.info.cap;
    this.provinciaAllievo = this.info.provinciaUtente;
  }

  created(){
    // console.log("chiamo")
    //   bus.$emit("loadColloqui")
    //   var userInfo = user.readUserInfo(this["$store"])
    //   if(userInfo.ruoloUtente.includes(3) || userInfo.ruoloUtente.includes(9)){
    //       var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    //   }
  }
}
